import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Documento } from '../../pages/documentos/documento/documento';
import { Http } from '@angular/http';
import { LoaderService } from '../loader/loader.service';
import 'rxjs/add/operator/finally';
@Injectable()
export class DocumentoService {

    apiUrl:string;
	constructor(private router: Router, private http: HttpClient, private loader: LoaderService) {
		this.apiUrl = environment.apiUrl;
	}


	carregar(id:number){
		this.loader.show();
		return this.http.get<Documento>(this.apiUrl + "/documento/"+id).finally(()=>{
			this.loader.hide();
		});
	}

    exportar(filtrourl){
		this.loader.show();
		return this.http.get<Documento>(filtrourl).finally(()=>{
			this.loader.hide();
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/documento/documento.service.ts